// originProjectSlice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {OriginProjectsClient, IOriginProjectsClient } from "app/ApiClient";
import { IState } from "../index";
import { defaultROriginProjectsState, NormalizedROriginProject } from "./rOriginProjectState";

const rOriginProjectsClient: IOriginProjectsClient = new OriginProjectsClient(process.env.REACT_APP_API_URL);

export const rOriginProjectsSlice = createSlice({
  name: "rOriginProjectsState",
  initialState: defaultROriginProjectsState,
  reducers: {
    resetROriginProjects: () => defaultROriginProjectsState,
    rOriginProjectsStarted: (state) => {
      state.processing = true;
      state.finished = false;
      state.succeed = false;
      state.failed = false; 
    },
    rOriginProjectsSucceed: (state, { payload }: { payload: NormalizedROriginProject[] }) => {
      state.processing = false;
      state.finished = true;
      state.succeed = true;
      state.failed = false;
      state.rOriginProjects = payload;
    },
    rOriginProjectsFailed: (state) => {
      state.processing = false;
      state.finished = true;
      state.succeed = false;
      state.failed = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getROriginProjects.fulfilled, (state, action) => {
        state.processing = false;
        state.finished = true;
        state.succeed = true;
        state.failed = false;
        state.rOriginProjects = action.payload;
      })
      .addCase(getROriginProjects.rejected, (state) => {
        state.processing = false;
        state.finished = true;
        state.succeed = false;
        state.failed = true;
      });
  },
});

export const getROriginProjects = createAsyncThunk(
  "originProject/GetROriginProjects",
  async (_, { dispatch }) => {
    dispatch(rOriginProjectsSlice.actions.rOriginProjectsStarted());
    try {      
      const response = await rOriginProjectsClient.getROriginProjects(); 
      dispatch(rOriginProjectsSlice.actions.rOriginProjectsSucceed(response as NormalizedROriginProject[]));
      return response as NormalizedROriginProject[];
    } catch (apiException) {
      dispatch(rOriginProjectsSlice.actions.rOriginProjectsFailed());      
      throw apiException;
    }
  },
);

export const { rOriginProjectsSucceed, rOriginProjectsFailed, rOriginProjectsStarted, resetROriginProjects } = rOriginProjectsSlice.actions;

export const rOriginProjectsSelector = (state: IState) => state.rOriginProjects;
export default rOriginProjectsSlice.reducer;
